import { createFileRoute } from '@tanstack/react-router';
import ManagerPortal from '../../components/portals/ManagerPortal';
import PromoValidation from '../../components/reception/PromoValidation';

export const Route = createFileRoute('/manager/promos')({
  component: ManagerPromosRoute,
});

function ManagerPromosRoute() {
  return (
    <ManagerPortal>
      <PromoValidation />
    </ManagerPortal>
  );
}
